import React from "react";
import App from "./../app.jsx";

import Login from "../pages/Login.jsx";
import WelcomePage from "../pages/WelcomePage.jsx";
import KioskSetup from "../pages/Kiosk/KioskSetup.jsx";
import SecurityQuestion from "../pages/SecurityQuestion.jsx";
import KioskNotice from "../pages/Kiosk/KioskNotice.jsx";
import MyProfile from "../pages/MyProfile.jsx";
import MyInvites from "../pages/MyInvites.jsx";
import LawLibrary from "../pages/LawLibrary.jsx";
import Commissary from "../pages/Commissary.jsx";
import MyMessage from "../pages/Message/MyMessage.jsx";
import Documents from "../pages/Documents.jsx";
import MyContacts from "../pages/MyContacts.jsx";
import Photos from "../pages/Photos.jsx";
import PostalMail from "../pages/PostalMail.jsx";
import Requests from "../pages/Requests/Requests.jsx";
import Dashboard from "../pages/Dashboard.jsx";
import Termsofservice from "../components/common/Termsofservice.jsx";
import PrivacyPolicy from "../components/common/PrivacyPolicy.jsx";
import Error from "../pages/error/error.js";
import MaintenancePage from "../pages/MaintenancePage.jsx";
import PublicRoute from "../_helpers/PublicRoute.js";
import E_Card from "../pages/E_Card/E_Card.jsx";
import ErrorPage from "../pages/error/ErrorPage.jsx";
import VideoCall from "../pages/VideoCall.jsx";

const AppRoute = [
  {
    path: "*",
    element: <App />,
    children: [
      {
        path: 'MyMessage',
        element: <MyMessage />
      },
      {
        path: 'Documents',
        element: <Documents />
      },
      {
        path: 'MyContacts',
        element: <MyContacts />
      },
       {
        path: 'Visitation',
        element: <VideoCall />
      },
      {
        path: 'Photos',
        element: <Photos />
      },
      {
        path: 'PostalMail',
        element: <PostalMail />
      },
      {
        path: 'Requests',
        element: <Requests />
      },
      {
        path: 'Dashboard',
        element: <Dashboard />
      },
      {
        path: 'MyProfile',
        element: <MyProfile />
      },
      {
        path: 'MyInvites',
        element: <MyInvites />
      },
      {
        path: 'LawLibrary',
        element: <LawLibrary />
      },
      {
        path: 'Commissary',
        element: <Commissary />
      },
      {
        path: 'E-Card',
        element: <E_Card />
      },
      {
        path: "*",
        element: <Error />
      },
    ],
  },
  {
    path: "/",
    element: (<PublicRoute> <WelcomePage /> </PublicRoute>)
  },
  {
    path: "login",
    element: <PublicRoute> <Login /> </PublicRoute>,
  },
  {
    path: "KioskSetup",
    element: <PublicRoute> <KioskSetup /> </PublicRoute>
  },
  {
    path: "SecurityQuestion",
    element: <PublicRoute> <SecurityQuestion /> </PublicRoute>
  },
  {
    path: 'KioskNotice',
    element: <PublicRoute> <KioskNotice /> </PublicRoute>
  },
  {
    path: "/termsofservice",
    element:  <Termsofservice />,
  },
  {
    path: "/privacyPolicy",
    element: <PrivacyPolicy /> ,
  },
  {
    path: "*",
    element: <Error />
  },
  {
    path: "/maintenance",
    element: <MaintenancePage />
  },
  {
    path:"Error",
    element: <ErrorPage/>
  }
];

export default AppRoute;
